"use client";

import { useEffect } from "react";
import { resolveAuthNextPath } from "@/lib/auth/nextPath";
import { useTrackEvent } from "@/hooks/useTrackEvent";
import { ANALYTICS_EVENTS } from "@/lib/analytics/events";

export default function HashSessionHandler() {
  const trackEvent = useTrackEvent();
  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.startsWith("#") ? window.location.hash.slice(1) : "");
    const accessToken = params.get("access_token");
    const refreshToken = params.get("refresh_token");

    if (!accessToken || !refreshToken) {
      return;
    }

    const nextPath = resolveAuthNextPath(new URLSearchParams(window.location.search).get("next"));

    void import("@/lib/supabase/client").then(({ createSupabaseBrowserClient }) => {
      const supabase = createSupabaseBrowserClient();
      return supabase.auth.setSession({ access_token: accessToken, refresh_token: refreshToken });
    })
      .then(({ error }) => {
        if (error) {
          console.error("[auth/hash-session] setSession failed", error.message);
          return;
        }

        const cleanUrl = `${window.location.pathname}${window.location.search}`;
        window.history.replaceState(null, "", cleanUrl);
        trackEvent(ANALYTICS_EVENTS.loginCompleted, {
          method: "magic-link",
          next_path: nextPath,
        });
        window.location.replace(nextPath);
      })
      .catch((error) => {
        console.error("[auth/hash-session] unexpected failure", error);
      });
  }, [trackEvent]);

  return null;
}
